import React, { useCallback, useEffect, useRef, useState } from "react";
import Header from "../../../Header";
import CrmLeadsHeader from "./components/CrmLeadsHeader";
import CustomerDetailsForm from "./components/CustomerDetailsForm";
import MuviOwnershipForm from "./components/MuviOwnershipForm";
import OtherContactsForm from "./components/OtherContactsForm";
import AppDetailsPanel from "./components/AppDetailsPanel";
import "./css/all-style.css";
import "./css/responsive.css";
import "./css/style.css";
import {
  NavLink,
  Redirect,
  useParams,
} from "react-router-dom/cjs/react-router-dom";
import NotesPanel from "./components/NotesPanel";
import ActivityPanel from "./components/ActivityPanel";
import OverviewPanel from "./components/OverviewPanel";
import RevenueBillingPanel from "./components/RevenueBillingPanel";
import { decompressjsondata, decrypt } from "../../../actions/common";
import { Toaster } from "react-hot-toast";
import TrackingInfoForm from "./components/TrackingInfoForm";
import { getCookie } from "../customer/Utility";
import InfraUsagePanel from "./components/InfraUsagePanel";
import Pako from "pako";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";

import EngagementDetails from "./components/EngagementDetails";
import AboutThisContactForm from "./components/AboutThisContactForm";
import { checkCrmPermission } from "../../common/Utility";
import { apiRequest } from "../../../utils/utils";
import ActivitySummary from "./components/ActivitySummary";

const idsToCheck = [
  '3D28C83C85544F0D9517DD2E7C7EEDAA',
  '49F37046FCD84520895FC18A4F5BFC8B'
];

const CrmLeadsDetails = ({ appToken }) => {
  var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
  var localdata = has_local_data
    ? decrypt(localStorage.getItem("encdata"), 0)
    : "";
  const userId = parseInt(has_local_data ? localdata.user_id : 0);
  const history = useHistory();

  if (!localStorage.getItem("userLogin")) {
    return <Redirect to={"/login"} />;
  }

  const { customer_identifier } = useParams();
  const [customerDetails, setCustomerDetails] = useState({});
  const [industryList, setIndustryList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [currentUser, setCurrentUser] = useState({});
  const [editPermissions, setEditPermissions] = useState(true);
  const [noteId, setNoteId] = useState(null);
  const [selectedTab, setSelectedTab] = useState("overview");
  const [columnsDef, setColumnsDef] = useState([]);
  const [ticketList, setTicketList] = useState([]);
  const [userTokens, setUserTokens] = useState(null);
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [infraDetails, setInfraDetails] = useState({});
  const [appDetails, setAppDetails] = useState({});
  const [loading, setLoading] = useState(true);

  const studioId = parseInt(customerDetails.customer_id);
  const [ismuvi5, setIsmuvi5] = useState(false);
  const location = useLocation();

  
  useEffect(() => {
    const permission = checkCrmPermission();
    setEditPermissions( permission ? true : false);
  }, []);
  

  useEffect(() => {
    document.title = `Intranet | ${customerDetails.company_name ? customerDetails.company_name : "Contact Details"}`;
  }, [customerDetails.company_name]);

  useEffect(
    function () {
      if (customerDetails && customerDetails.customer_id !== undefined) {
        var id = customerDetails.customer_id;
        var isValidNumber =
          typeof id === "number"
            ? isFinite(id)
            : typeof id === "string" && /^[0-9]+$/.test(id);

        setIsmuvi5(isValidNumber);
        if (isValidNumber) {
          setUserTokens(null);
        }
        setLoading(false);
      }
      setTimeout(() => {
        setLoading(false);
      }, 5000);
    },
    [customerDetails],
  );

  const hasFetchedRef = useRef(false);
  // Initialize State Variables
  useEffect(() => {
    FetchIndustryList();
    FetchProductsList();
    fetchUsersList();

  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    const noteId = hash.startsWith("#note") ? hash.substring(5) : null;

    if (noteId) {
      setSelectedTab("notes");
    }

    setNoteId(noteId);
  }, [window.location, window.location.hash]);

  // Fetch customer details when customer_identifier changes
  useEffect(() => {
    fetchCustomerDetails();
    fetchColumnsDef();
  }, [customer_identifier]);

  useEffect(() => {
    if (
      !userTokens
    ) {
      return
    }
    const fetchAll = async () => {
      try {
        await Promise.all([
          fetchSubscriptionDetails(),
          fetchInfraData(),
        ]);
        // hasFetchedRef.current = true;
      } catch (err) {
        console.error("Billing fetch error:", err);
      } finally {

      }
    };
    if (!ismuvi5) {
      fetchAll();
    }

  }, [userTokens, ismuvi5]);

  const fetchCustomerTickets = async (customer_id, account_type) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_tattle_api}/tattle/rows`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            app_token: process.env.REACT_APP_tattle_token,
            attribute_set_key: "support-ticket",
            filter: {
              company_name: [customer_id],
              ...(account_type === "customer" && {
                status: [
                  "6369173fdc5b5c3fe226781b",
                  "6369173fdc5b5c3fe226781e",
                  "676e6162510f5a57ea0904a6",
                  "6369173fdc5b5c3fe226781c"
                ]
              })
            },
            per_page: 20,
            current_page: 1,
            attribute_set_type: 2,
          })

        }
      );

      const data = await response.json();

      if (data.code === 200) {
        setTicketList(data.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch customer tickets:", error);
    }
  };
  let user_uuid = getCookie("muvi_useruuid");

  const fetchColumnsDef = async () => {
    try {
      const requestdata = {
        app_token: process.env.REACT_APP_tattle_token,
        attribute_set_key: "support-ticket",
        user_uuid: user_uuid,
      };

      const rdata = await fetch(
        `${process.env.REACT_APP_tattle_api}/tattle/list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestdata),
        }
      );

      const data = await rdata.json();

      if (data.code === 200) {
        setColumnsDef(data.data || []);
      }
    } catch (error) {
      console.error("Error fetching column definitions:", error);
    }
  };

  const fetchUsersList = () => {
    fetch(`${process.env.REACT_APP_CRM}/user-list`, {
      method: "POST",
    })
      .then((resp) => {
        return resp.json();
      })
      .then((data) => {
        if (data.code == 200) {
          const userList = data.data;
          setUsersList(userList);

          const userData = data.data;
          for (const key in userData) {
            if (userData.hasOwnProperty(key)) {
              const user = userData[key];
              if (user.emp_id == userId) {
                setCurrentUser({ ...user, userId: user.emp_id });
                break;
              }
            }
          }
        }
      });
  };

  const FetchIndustryList = () => {
    fetch(`${process.env.REACT_APP_CRM}/crm/industry-list`, {
      method: "GET",
    })
      .then((resp) => {
        return resp.json();
      })
      .then((data) => {
        if (data.code == 200 && data.data) {
          const industryData = data.data.map((item) => {
            return { value: item, id: item };
          });
          setIndustryList(industryData);
        }
      });
  };

  const FetchProductsList = () => {
    fetch(`${process.env.REACT_APP_CRM}/crm/product/list`, {
      method: "GET",
    })
      .then((resp) => {
        if (resp.status == 200) {
          return resp.json();
        }
      })
      .then((data) => {
        if (data) {
          const redata = data.map(({ product_name, product_key }) => ({
            id: product_key,
            value: product_name,
            product_key: product_key,
          }));

          setProductsList(redata);
        }
      });
  };

  const fetchCustomerDetails = async () => {
    //TODO: Get this from ENV
    const mauticURL =
      process.env.REACT_APP_CRM_ADMIN

    let url = mauticURL;

    if (!isNaN(customer_identifier)) {
      url += "/api/crm/contact/id/" + customer_identifier;
    } else if (/\S+@\S+\.\S+/.test(customer_identifier)) {
      url += "/api/crm/contact/email/" + customer_identifier;
    } else {
      url += "/api/crm/contact/customer-id/" + customer_identifier;
    }

    const findresponse = await apiRequest(url, "POST", {
      additional_info: ["next_prev_contact"],
    },null, true);

    if (findresponse && findresponse.code === 200) {
      const data = findresponse.data;

      if (!data) return;

      const { customer_id, customer_user_uuid, other_contacts = [] } = data;

      // Fire APIs (can be parallel)
      if (customer_id) {
        if (customer_user_uuid && parseInt(customer_id) != customer_id) {
          // setLoading(true);
          fetchAccessTokens(customer_id, customer_user_uuid);
        }
        fetchCustomerTickets(customer_id, data.account_type);
      } else {
        setUserTokens(null)
      }
      // Set customer details
      setCustomerDetails({
        ...data,
        appToken: customer_id,
        otherContacts: other_contacts,
      });
    } else {
      history.push("/contacts/list");
    }
  };

  const fetchAccessTokens = async (app_token = "", user_uuid = "") => {
    try {
      const payload = {
        app_token,
        user_uuid,
      };

      const response = await fetch(
        `${process.env.REACT_APP_CRM}/get-access-token`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      if (
        data &&
        data.access_token &&
        data.access_token.response &&
        data.access_token.response.access_token
      ) {
        setUserTokens(data.access_token.response.access_token);
      }
      return data;
    } catch (error) {
      console.error("Failed to fetch access tokens:", error);
      return null;
    }
  };

  const graphqlRequest = useCallback(
    async (url, { query }) => {
      const response = await fetch(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userTokens,
          },
          body: JSON.stringify({ query }),
        }
      );

      if (!response.ok) {
        throw new Error("HTTP error: " + response.status);
      }

      const result = await response.json();

      if (result.errors) {
        throw new Error(
          result.errors.map(function (e) {
            return e.message;
          }).join(", ")
        );
      }

      return result.data ? result.data : result;
    },
    [userTokens]
  );

  const fetchSubscriptionDetails = async () => {
    try {
      const query = `{ subscriptionDetails(app_token: ":app_token") { add_ons { product_name plan_name plan_uuid pricing_uuid plan_price currency_symbol currency_code plan_duration plan_status billing_period next_billing_date is_cancel_requested will_cancel_on subscription_status } base_plan { product_name product_key plan_name plan_price currency_symbol currency_code plan_duration account_status billing_period subscription_starts subscription_expiry next_billing_date next_infra_billing_date will_delete_on current_infra_billing_period applications add_ons } infra { product_name plan_status plan_duration billing_period next_billing_date } } }`;
      const graphqlurl = `${customerDetails.enterprise_api_gateway_url ? customerDetails.enterprise_api_gateway_url : process.env.REACT_APP_APIGETWAY}/customer/billing`;
      setLoading(true);
      const data = await graphqlRequest(graphqlurl, { query });

      setSubscriptionList(
        data && data.subscriptionDetails && data.subscriptionDetails.base_plan ? data.subscriptionDetails.base_plan : []
      );
    } catch (error) {
      console.error("Error fetching subscription details:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchInfraData = useCallback(async () => {
    const query = `{}`;
    const graphqlurl = `${customerDetails.enterprise_api_gateway_url ? customerDetails.enterprise_api_gateway_url : process.env.REACT_APP_APIGETWAY}/customer/infra-wallet/details`;
    const data = await graphqlRequest(graphqlurl, { query });
    setInfraDetails(
      data.current_cycle_infra_data
    );
  }, [graphqlRequest, customer_identifier]);

  const isDebug = () => {
    const searchParams = new URLSearchParams(location.search);
    const queryString = searchParams.get("debug");
    const debug = queryString == null || queryString == "false" ? false : true;
    return debug;
  };

  const getMuvi5Infra = () => {

    const debug = isDebug();
    let bodyParams = {
      studio_id: studioId,
      created_date: "2026-01-01",
      debug,
    };

    const compressedPostData = debug
      ? JSON.stringify(bodyParams)
      : Pako.gzip(JSON.stringify(bodyParams));
    fetch(`${process.env.REACT_APP_CRM_PROD}/muvi5/get-bandwidth`, {
      method: "POST",
      dataType: "json",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug ? buffer : decompressjsondata(buffer);
        var totalBandwidth =
          findresponse &&
          findresponse.result &&
          findresponse.result[0] &&
          findresponse.result[0].total_bandwidth;

        var totalBandwidth =
          findresponse &&
          findresponse.result &&
          findresponse.result[0] &&
          findresponse.result[0].total_bandwidth;

        // update state using prev (immutable)
        setInfraDetails(function (prev) {
          // if no bandwidth, return prev as-is
          if (totalBandwidth === null || totalBandwidth === undefined) {
            return prev;
          }

          return Object.assign({}, prev, {
            bandwidth: {
              name: "Bandwidth",
              total: totalBandwidth,
              consumed: "NA",
              available: "NA",
              percentage: "NA",
              extra: "0 GB"
            }
          });
        });

      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }

  useEffect(() => {
    const infra = {
      storage: {
        name: "Storage",
        total: "NA",
        consumed: appDetails.storage || "NA",
        available: "NA",
        percentage: "NA",
        extra: "0 GB",
      },
    };

    if (ismuvi5) {
      setInfraDetails(infra)
    }
  }, [ismuvi5, appDetails]);

  useEffect(() => {
    if (!ismuvi5 && !studioId) {
      return
    }
    getMuvi5Infra()
  }, [ismuvi5]);


  return (
    <div className="crm-leads-details">
      <Header
        brecum_name="CRM"
        // brecum_name="Contacts"
        brecum_page="Contact"
      />

      <Toaster
        toastOptions={{
          duration: 3000,
          position: "bottom-left",
        }}
      />
      <div class="right_col lead-account" style={{ paddingTop: "50px" }}>
        {/* customer details */}
        <div class="customer-details-area v2 notes crm">
          <div class="product-tab details-page p-0">
            <div
              class="h-full w-full d-flex gap-8"
              style={{ overflow: "hidden" }}
            >
              <div class="col-lg-4 col-md-12 p-8 card scrollable scrollable-y">
                <div class="flex-col gap-8">
                  <CrmLeadsHeader
                    customerDetails={customerDetails || {}}
                    productsList={productsList || []}
                    currentUser={currentUser || {}}
                    refreshCustomerDetails={fetchCustomerDetails}
                    ismuvi5={ismuvi5}
                  />
                  <div>
                    <ActivitySummary customerDetails={customerDetails || {}} />
                    <AboutThisContactForm
                      industryList={industryList || []}
                      productsList={productsList || []}
                      customerDetails={customerDetails || {}}
                      editPermissions={editPermissions}
                      refreshCustomerDetails={fetchCustomerDetails}
                    />
                    <EngagementDetails
                      industryList={industryList || []}
                      productsList={productsList || []}
                      customerDetails={customerDetails || {}}
                      editPermissions={editPermissions}
                      refreshCustomerDetails={fetchCustomerDetails}
                    />
                    <TrackingInfoForm
                      customerDetails={customerDetails || {}}
                      editPermissions={editPermissions}
                      refreshCustomerDetails={fetchCustomerDetails}
                    />
                    <MuviOwnershipForm
                      customerDetails={customerDetails || {}}
                      editPermissions={editPermissions}
                      refreshCustomerDetails={fetchCustomerDetails}
                      usersList={usersList || []}
                    />
                    <CustomerDetailsForm
                      customerDetails={customerDetails || {}}
                      editPermissions={editPermissions}
                      refreshCustomerDetails={fetchCustomerDetails}
                      usersList={usersList || []}
                    />
                    <OtherContactsForm
                      otherContacts={customerDetails.otherContacts || []}
                      companyName={customerDetails.company_name || ""}
                      refreshCustomerDetails={fetchCustomerDetails}
                      editPermissions={editPermissions}
                      customerDetails={customerDetails}
                    />
                  </div>
                </div>
              </div>
              <div
                class="col-lg-8 col-md-12 p-0 h-full d-flex flex-col"
                style={{ overflow: "hidden" }}
              >
                <div
                  class="w-full nav-tabs-container"
                  style={{ flexShrink: 0 }}
                >
                  <ul class="nav nav-tabs tablist" role="tablist">
                    <li
                      role="presentation"
                      class={selectedTab === "overview" ? "active" : ""}
                    >
                      <a
                        href="#overview"
                        aria-controls="overview"
                        role="tab"
                        aria-expanded={selectedTab === "overview"}
                        class="tab-button"
                        onClick={(e) => {
                          e.preventDefault();
                          setSelectedTab("overview");
                        }}
                      >
                        Overview
                      </a>
                    </li>
               
                    <li
                      role="presentation"
                      class={
                        selectedTab === "revenue-and-billing" ? "active" : ""
                      }
                    >
                      <a
                        href="#revenue-and-billing"
                        aria-controls="Billing"
                        role="tab"
                        aria-expanded={selectedTab === "revenue-and-billing"}
                        class="tab-button"
                        onClick={(e) => {
                          e.preventDefault();
                          setSelectedTab("revenue-and-billing");
                        }}
                      >
                        Billing
                      </a>
                    </li>
                    <li
                      role="presentation"
                      class={
                        selectedTab === "infra-usages" ? "active" : ""
                      }
                    >
                      <a
                        href="#infra-usages"
                        aria-controls="Infra Usages"
                        role="tab"
                        aria-expanded={selectedTab === "infra-usages"}
                        class="tab-button"
                        onClick={(e) => {
                          e.preventDefault();
                          setSelectedTab("infra-usages");
                        }}
                      >
                        Infra
                        </a>
                      </li>
                      {
                        Array.isArray(customerDetails.associated_products) &&
                        idsToCheck.some(id =>
                        customerDetails.associated_products.includes(id)
                        ) &&
                      (
                      <li
                        role="presentation"
                        class={selectedTab === "app-details" ? "active" : ""}
                      >
                        <a
                        href="#app-details"
                        aria-controls="app-details"
                        role="tab"
                        aria-expanded={selectedTab === "app-details"}
                        class="tab-button"
                        onClick={(e) => {
                          e.preventDefault();
                          setSelectedTab("app-details");
                        }}
                      >
                        App Details
                      </a>
                    </li>
                    )
                    }

                    <li
                      role="presentation"
                      class={selectedTab === "activity" ? "active" : ""}
                    >
                      <a
                        href="#activity"
                        aria-controls="overview"
                        role="tab"
                        aria-expanded={selectedTab === "activity"}
                        class="tab-button"
                        onClick={(e) => {
                          e.preventDefault();
                          setSelectedTab("activity");
                        }}
                      >
                        Activity
                      </a>
                    </li>
                    <li
                      role="presentation"
                      class={selectedTab === "notes" ? "active" : ""}
                    >
                      <a
                        href="#notes"
                        aria-controls="overview"
                        role="tab"
                        aria-expanded={selectedTab === "notes"}
                        class="tab-button"
                        onClick={(e) => {
                          e.preventDefault();
                          setSelectedTab("notes");
                        }}
                      >
                        Notes
                      </a>
                    </li>
                    <NavLink
                      to={{
                        pathname: "/contacts/list",
                      }}
                      className="back-toggle-btn"
                    >
                      <span
                        style={{
                          fontSize: "18px",
                          lineHeight: "20px",
                          color: "rgb(122, 122, 122)",
                        }}
                      >
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          stroke-width="0"
                          viewBox="0 0 24 24"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M21 11H6.414l5.293-5.293-1.414-1.414L2.586 12l7.707 7.707 1.414-1.414L6.414 13H21z"></path>
                        </svg>
                      </span>
                    </NavLink>
                  </ul>
                </div>
                <div
                  className="w-full"
                  style={{ flex: 1, overflow: "hidden", minHeight: 0 }}
                >
                  <div class="tab-content customer-details-tab-content p-8 scrollable scrollable-y">
                    <div
                      className={`tab-pane fade ${selectedTab === "overview" ? "in active" : ""
                        }`}
                      id="overview"
                      role="tabpanel"
                    >
                      <OverviewPanel
                        isActive={selectedTab === "overview" ? true : false}
                        userTokens={userTokens}
                        graphqlRequest={graphqlRequest}
                        ticketList={ticketList}
                        loading={loading}
                        infraDetails={infraDetails}
                        subscriptionList={subscriptionList}
                        customer_identifier={customer_identifier}
                        customerDetails={customerDetails}
                        appDetails={appDetails}
                        productsList={productsList}
                        ismuvi5={ismuvi5}
                        fetchSubscriptionDetails={fetchSubscriptionDetails}
                        columnsDef={columnsDef}
                        usersList={usersList}
                      />
                    </div>

                    <div
                      className={`tab-pane fade ${selectedTab === "infra-usages" ? "in active" : ""
                        }`}
                      id="infra-usages"
                      role="tabpanel"
                    >
                      <InfraUsagePanel
                        infraDetails={infraDetails}
                        loading={loading}
                      />
                    </div>
                    <div
                      className={`tab-pane fade ${selectedTab === "revenue-and-billing" ? "in active" : ""
                        }`}
                      id="revenue-and-billing"
                      role="tabpanel"
                    >
                      <RevenueBillingPanel
                        isActive={selectedTab === "revenue-and-billing" ? true : false}
                        userTokens={userTokens}
                        graphqlRequest={graphqlRequest}
                        loading={loading}
                        // infraDetails={infraDetails}
                        // subscriptionList={subscriptionList}
                        customerDetails={customerDetails}
                        appDetails={appDetails}
                        customer_identifier={customer_identifier}
                        ismuvi5={ismuvi5}
                      />
                    </div>
                    {
                      idsToCheck.some(id =>
                       Array.isArray(customerDetails.associated_products) && customerDetails.associated_products.length && customerDetails.associated_products.includes(id)
                      ) &&
                    (
                    <div
                      className={`tab-pane fade ${selectedTab === "app-details" ? "in active" : ""
                        }`}
                      id="app-details"
                      role="tabpanel"
                    >
                      <AppDetailsPanel
                        customerDetails={customerDetails || {}}
                        isActive={selectedTab === "app-details" ? true : false}
                        appDetails={appDetails}
                        setAppDetails={setAppDetails}
                        ismuvi5={ismuvi5}
                      />
                    </div>
                    ) }

                    <div
                      className={`tab-pane fade ${selectedTab === "activity" ? "in active" : ""
                        }`}
                      id="activity"
                      role="tabpanel"
                    >
                      <ActivityPanel
                        customerDetails={customerDetails || {}}
                        productsList={productsList || []}
                        usersList={usersList || []}
                        currentUser={currentUser || {}}
                      />
                    </div>
                    <div
                      className={`tab-pane fade ${selectedTab === "notes" ? "in active" : ""
                        }`}
                      id="notes"
                      role="tabpanel"
                    >
                      <NotesPanel
                        customerTattleUUID={
                          parseInt(customerDetails.customer_tattle_uuid) || ""
                        }
                        mauticId={customerDetails.mautic_id || ""}
                        usersList={usersList || []}
                        currentUser={currentUser || {}}
                        attribute_set_type={9}
                        customerName={customerDetails.name || ""}
                      />
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrmLeadsDetails;



// WEBPACK FOOTER //
// ./src/components/crm/leads/CrmLeadsDetails.js